import React, { useState, useRef, useEffect } from 'react';
import Calendar from './listing-calendar';
import ReservationModal from './reservation-form';

const BookingWidget = ({ onClose }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [confirmed, setConfirmed] = useState([]);
  const calendarRef = useRef(null);

  const handleDateSelect = date => {
    setSelectedDate(date);
    setShowModal(true); 
  };

  const handleConfirm = ({ name, email, primaryListingDate, secondaryListingDate }) => {
    setConfirmed(prev => [...prev, primaryListingDate]);
    setShowModal(false);
    setSelectedDate(null);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedDate(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        !showModal
      ) {
        if (typeof onClose === 'function') onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose, showModal]);

  const formattedprimaryListingDate = selectedDate
    ? (selectedDate instanceof Date
        ? selectedDate.toISOString().slice(0, 10)
        : selectedDate)
    : '';

  return (
    <div className="booking-widget">
      {!showModal && (
        <div ref={calendarRef} className="calendarWrapperStyle">
          <Calendar
            onDateSelect={handleDateSelect}
            reservedDates={confirmed}
          />
        </div>
      )}

      <ReservationModal
        show={showModal}
        onHide={handleClose}
        primaryListingDate={formattedprimaryListingDate}
        onConfirm={handleConfirm}
      />
    </div>
  );
}

export default BookingWidget;
